import { MEMBER_STORAGE_KEYS } from '../constants/storageKeys';
import { clearMemberSession } from '../auth/tokenStorage';
import { createApiClient } from './createClient';

/** IM HTTP client — same member JWT as memberRequest. */
const imRequest = createApiClient({
  storageKeys: MEMBER_STORAGE_KEYS,
  clearSession: clearMemberSession,
  expiredEvent: 'formosa:auth-expired',
});

export default imRequest;
